import apiClient from '../utilities/apiClient.utility';

const userUrl = `${window.config.CONNECT_URLS.users}`;

export const postUpdatePassword = async (payload) => {
    return await apiClient.post(
      `${userUrl}/${window.programConfig.program_id}/profile/update-password`,
      payload
    );
};

export const activateUser = async (payload) => {
  const { program_id, id } = payload;
  return await apiClient.post(
    `${userUrl}/${program_id}/dashboard/user/${id}/activate`, {}
  );
}

export const deactivateUser = async (payload) => {
  const { program_id, id } = payload;
  return await apiClient.post(
    `${userUrl}/${program_id}/dashboard/user/${id}/deactivate`, {}
  );
}

export const updateUserInfo = async ({ program_id, id, payload }) => {
  return await apiClient.put(
    `${userUrl}/${program_id}/dashboard/user/${id}`, payload
  );
}

export const updateUserChasCard = async ({ program_id, id, payload, action }) => {
  return await apiClient.post(
    `${userUrl}/${program_id}/dashboard/user/${id}/chas/${action}`, payload
  );
}

export const manuallyCreateUser = async ({ program_id, payload }) => {
  return await apiClient.post(
    `${userUrl}/${program_id}/dashboard/user/manual-pre-registration`, payload
  );
}

export const manuallyRegisterUser = async ({ program_id, payload }) => {
  return await apiClient.post(
    `${userUrl}/${program_id}/dashboard/user/manual-registration`, payload
  );
}

export const sendHcpPrefilledLink = async ({ program_id, payload }) => {
  return await apiClient.post(
    `${userUrl}/${program_id}/dashboard/user/send-prefilled-link`, payload
  );
}

export const getAllDoctors = async ({ program_id }) => {
  return await apiClient.get(
    `${userUrl}/${program_id}/dashboard/user/getHCPList?user_type=doctor&order_by=full_name`
  );
}

export const getFieldList = async ({ program_id, name }) => {
  return await apiClient.get(
    `${userUrl}/${program_id}/dashboard/user-fields/${name}`
  );
}

export const approvePatientRegistration = async (payload) => {
  const { program_id, id } = payload;
  return await apiClient.post(
    `${userUrl}/${program_id}/dashboard/user-registration/${id}/approve`, {}
  );
}

export const rejectPatientRegistration = async (payload) => {
  const { program_id, id } = payload;
  return await apiClient.post(
    `${userUrl}/${program_id}/dashboard/user-registration/${id}/reject`, {}
  );
}

export const approvePatientPrescription = async (payload) => {
  const { program_id, user_id } = payload;
  return await apiClient.post(
    `${userUrl}/${program_id}/dashboard/user/${user_id}/prescriptionapprove`, {}
  );
}

export const disapprovePatientPrescription = async (payload) => {
  const { program_id, user_id } = payload;
  return await apiClient.post(
    `${userUrl}/${program_id}/dashboard/user/${user_id}/prescriptiondisapprove`, {reason: payload.reason }
  );
}

export const getPrescriptionConfig = async ({ program_id }) => {
  return await apiClient.get(
    `${userUrl}/${program_id}/admin/config/user-types/patient`
  );
}

export const getAllPrivateHospital = async ({ program_id }) => {
  return await apiClient.get(
    `${userUrl}/${program_id}/dashboard/user/getHCPList?user_type=private_hospital`
  );
}
export const manuallyPatientUpdate = async ({ program_id, patient_id, payload }) => {
  return await apiClient.post(
    `${userUrl}/${program_id}/dashboard/user/manual-patient-update/${patient_id}`, payload
  );
}

export const updatePrescription = async ({ program_id, patient_id, prescription }) => {
  return await apiClient.post(
    `${userUrl}/${program_id}/dashboard/user/prescription/${patient_id}`,
    { prescription }
  );
};

export const getHospitalList = async (program_id: string, use_parent_program = true) => {
  try {
    const response = await apiClient.get(
      `${userUrl}/${program_id}/hcp/hospital-list?use_parent_program=${use_parent_program}`
    );

    return response;
  } catch (e) {
    console.log(e);
    return 'No content';
  }
}

export const getDoctorList = async (program_id: string, hospital: string, use_parent_program = true) => {
  try {
    const response = await apiClient.get(
      `${userUrl}/${program_id}/hcp/doctor-list?hospital=${hospital}&use_parent_program=${use_parent_program}`
    );

    return response;
  } catch (e) {
    console.log(e);
    return 'No content';
  }
}

export const approveRejectPatientRegistration = async ({ program_id, id, action, payload }) => {
  return await apiClient.post(
    `${userUrl}/${program_id}/dashboard/user-registration/${id}/${action}`, payload
  );
}

export const getAllHCPList = async ({ program_id }) => {
  return await apiClient.get(
    `${userUrl}/${program_id}/dashboard/user/getHCPList?user_type=doctor`
  );
}

export const getPharmacyList = async ({ program_id }) => {
  return await apiClient.get(
    `${userUrl}/${program_id}/dashboard/user/getHCPList?user_type=pharmacist&order_by=full_name`
  );
}

